import { render, staticRenderFns } from "./EmailConfiguration.vue?vue&type=template&id=6d0d7d60&scoped=true&"
import script from "./EmailConfiguration.vue?vue&type=script&lang=js&"
export * from "./EmailConfiguration.vue?vue&type=script&lang=js&"
import style0 from "./EmailConfiguration.vue?vue&type=style&index=0&id=6d0d7d60&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d0d7d60",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Globaltask\\Documents\\Proyects\\Happybox\\happyboxstore-repo\\email-shipping\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6d0d7d60')) {
      api.createRecord('6d0d7d60', component.options)
    } else {
      api.reload('6d0d7d60', component.options)
    }
    module.hot.accept("./EmailConfiguration.vue?vue&type=template&id=6d0d7d60&scoped=true&", function () {
      api.rerender('6d0d7d60', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "EmailShipping/components/EmailConfiguration.vue"
export default component.exports